import { render, staticRenderFns } from "./CBoardLeftItem.vue?vue&type=template&id=7b6934fa&"
import script from "./CBoardLeftItem.vue?vue&type=script&lang=ts&"
export * from "./CBoardLeftItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports